import React, { useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { FaPlay } from "react-icons/fa";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Layout from "../../layout/Layout";
import { Movies } from "./Data/MovieData";

const WatchPage = () => {
  let { id } = useParams();
  const movie = Movies.find((movie) => movie.name === id);
  const [play, setPlay] = useState(false);
  return (
    <Layout>
      <div className="container mx-auto bg-dry p-6 mb-12">
        <div className=" mb-6 gap-2 bg-main rounded border border-gray-800 p-6">
          <Link
            to={`/movies/${movie?.name}`}
            className="md:text-xl text-sm flex gap-3 items-center font-bold text-text"
          >
            <BiArrowBack /> {movie?.name}
          </Link>

          {play ? (
            <video controls autoPlay={play} className="w-full h-full rounded">
              <source
                src={`${movie?.video}`}
                type="video/mp4"
                title={movie?.name}
              />
            </video>
          ) : (
            <div className="w-full h-screen rounded-lg overflow-hidden relative">
              <div className="absolute top-0 left-0 bottom-0 right-0 bg-main bg-opacity-30 flex-colo">
                <button
                  onClick={() => setPlay(true)}
                  className="bg-white text-subMain flex-colo border border-subMain rounded-full w-20 h-20 font-medium text-xl"
                >
                  <FaPlay />
                </button>
              </div>
              <img
                src={movie?.image ? `${movie?.image}` : "images/contact-us.png"}
                alt={movie?.name}
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default WatchPage;
